export default function removeFlowerFromScene(flowerGroup) {
    flowerGroup.children.forEach(child => {
      if (child.geometry) {
        child.geometry.dispose();
      }
      if (child.material) {
        if (Array.isArray(child.material)) {
          child.material.forEach(mat => mat.dispose());
        } else {
          child.material.dispose();
        }
      }
    });
    flowerGroup.clear(); 
  }
  